import $ from 'jquery';

import Vars from '../../vars'

import Action from "../classes/Action";

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

import Section from './Section';

class Chess {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init(args);
    }

    _elems = {
        $_         : $('.chess'),
        $container : $('.chess__container'),
        $wrapper   : $('.chess__container .wrapper'),
        $slider	   : $('.chess__slider'),
        $control   : $('.chess__control')
    };

    _args = {
        object       : {},
        building     : {},
        progress     : {},
        buildingSelf : {}
    };

    _state = {
        currentSection      : {},
        currentSectionIndex : 0,
        scrolling           : false,
        afterScroll         : false,
        selected_floors     : {},
        selected_flats      : {},
        floor_models        : [],
        controlSection      : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.object       = args.object;
        self._args.building     = args.building;
        self._args.progress     = args.progress || self._args.progress;

        self._args.buildingSelf = args.buildingSelf || self._args.buildingSelf;
    };

    _getFlatByIndexes = (section, floor_index, column_index) => {
        let flat = null;
        if (floor_index < 0 || floor_index >= section.floors.length) return flat;

        let floor = section.floors[floor_index];
        section.flats.some(function(current_flat) {
            if (current_flat.floor_id != floor.id) return false;
            if (current_flat.column_index != column_index) return false;
            flat = current_flat;
            return true;
        });

        return flat;
    };

    _getFlatById = (section, id) => {
        let flat = null;

        if (section.flats.filter(function(f){
            return  f.id == id;
        }).length) {
            flat = section.flats.filter(function(f){
                return  f.id == id;
            })[0];
        }

        return flat;
    };

    _getFlatSiblingClasses = (self, section, flat) => {
        if (!flat.group) return [];

        let sibling_classes = [];
        let sibling_classes_names = [
            [ 'bottom-left', 'bottom', 'bottom-right' ],
            [ 'left', null, 'right' ],
            [ 'top-left', 'top', 'top-right' ],
        ];

        for (let floor_offset = -1; floor_offset < 2; ++floor_offset) {
            for (let column_offset = -1; column_offset < 2; ++column_offset) {
                let sibling_classes_name = sibling_classes_names[floor_offset + 1][column_offset + 1];

                if (!sibling_classes_name) continue;

                let floor = self.getFloorById(section, flat.floor_id);
                let floor_index = floor.index + floor_offset;
                let column_index = flat.column_index + column_offset;
                let sibling_flat = self.getFlatByIndexes(section, floor_index, column_index);

                if (!sibling_flat) continue;
                if (!sibling_flat.group) continue;
                if (sibling_flat.group.id != flat.group.id) continue;

                sibling_classes.push(sibling_classes_name);
            }
        }

        return sibling_classes;
    };

    _getFloorModel = (self, section, floor_index) => {
        if (section.floors[floor_index].plans.length === 0) return null;

        let floor_model = null;

        self._state.floor_models.some(function(current_floor_model) {
            let is_the_same = current_floor_model.plan_ids.join('.') === section.floors[floor_index].plans.map(function(plan) {
                return plan.id;
            }).join('.');

            if (!is_the_same) return false;

            floor_model = current_floor_model;
            return true;
        });

        if (floor_model) return floor_model;

        floor_model = {
            plan_ids: section.floors[floor_index].plans.map(function(plan) {
                return plan.id;
            }),
            color: Vars.colors[self._state.floor_models.length]
        };

        self._state.floor_models.push(floor_model);
        return floor_model;
    };

    _isFlatOnPlan = (section, floor_index, column_index) => {
        if (section.floors[floor_index].plans.length === 0) return false;

        return section.floors[floor_index].plans.some(function(plan) {
            return plan.polygons.some(function(polygon) {
                return polygon.column_indexes.indexOf(column_index) > -1;
            });
        });
    };
    
    _updateSections = () => {
        let self = this;

        const maximumCountOfFloors = Math.max.apply(Math, self._args.building.sections.map(function(section) {
            return section.count_of_floors;
        }));

        let $chessSections = self._elems.$slider.children('.chess__section');
        if (!$chessSections.length) return;

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(section, sectionIndex) {
            const showingNumbers = $chessSections.eq(sectionIndex).children('.chess-section').hasClass('showing-numbers');

            let $section = $chessSections.eq(sectionIndex).html(Utils.renderProfileTemplate('section', {
                self                      : self,
                building:                   self._args.building,
                section: 					section,
                section_index: 				sectionIndex,
                maximum_count_of_floors: 	maximumCountOfFloors,
                get_flat_by_indexes: 		self._getFlatByIndexes,
                get_flat_by_id:      		self._getFlatById,
                get_floor_model: 			self._getFloorModel,
                is_flat_on_plan: 			self._isFlatOnPlan,
                get_flat_sibling_classes: 	self._getFlatSiblingClasses
            })).children('.chess-section');

            $chessSections.eq(sectionIndex).css({'order': section.number});

            showingNumbers && $section.addClass('showing-numbers');

            new Section({
                mode     : Vars.view.building,
                building : self._args.building,
                progress : self._args.progress,
                item     : section,
                index    : sectionIndex,
                chess    : self,
                root     : $section,
                controlSection : self._state.controlSection
            });

            self._updateFlatTitles();
            self._state.selected_flats[section.id] = [];
            self._state.selected_floors[section.id] = [];
        });

        if (self._args.building.sections && self._args.building.sections.length > 0) self._elems.$container.css('height', self._elems.$slider.height() + 'px');
        else self._elems.$container.css('height', '');

        self._state.currentSection = null;
        self._state.currentSectionIndex = -1;
    };

    _updateCurrentSection = () => {
        let self = this;

        let current_section = null, current_section_index = -1;

        self._elems.$slider.children().toArray().some(function(element, element_index) {
            if ($(element).position().left > 0 || $(element).position().left + $(element).width() <= 0)
                return false;

            current_section = element;
            current_section_index = element_index;
            return true;
        });

        if (current_section) {
            self._state.currentSection = $(current_section);

            if (self._state.currentSectionIndex != current_section_index) {
                self._state.currentSectionIndex = current_section_index;

                $('.chess-section').removeClass('current');
                $('.chess-section__name').css({width: '', left: 0});
                $('.chess-section__name-container').removeClass('activated');
                $('.chess-section__floor-container').removeClass('activated');
                self._state.currentSection.children().addClass('current');
                self._state.currentSectionIndex = current_section_index;
            }

            let $current_section_floors = self._state.currentSection.find('.chess-section__floors');
            let $current_section_floor_selections = self._state.currentSection.find('.chess-section__floor-selections');
            let floors_width = $current_section_floors.outerWidth();
            let floor_selections_width = $current_section_floor_selections.outerWidth();
            let $current_section_name = self._state.currentSection.find('.chess-section__name');

            if (floors_width + floor_selections_width + 27 * 2 + 7 > self._state.currentSection.position().left + self._state.currentSection.width()) {
                self._state.currentSection.find('.chess-section__name-container').addClass('activated');
            }
            else {
                self._state.currentSection.find('.chess-section__name-container').removeClass('activated');
                $current_section_name.css({
                    width: (self._state.currentSection.position().left + self._state.currentSection.width()) + 'px',
                    right: 0,
                    left: 'auto'
                });
            }

            if (floors_width + floor_selections_width > self._state.currentSection.position().left + self._state.currentSection.width()) {
                self._state.currentSection.find('.chess-section__floor-container').addClass('activated');
            }
            else {
                self._state.currentSection.find('.chess-section__floor-container').removeClass('activated');
            }
        }
        else {
            self._state.currentSection = null;
            self._state.currentSectionIndex = -1;
            $('.chess-section').removeClass('current');
            $('.chess-section__name').css(({width: '', left: 0}));
            $('.chess-section__name-container').removeClass('activated');
            $('.chess-section__floor-container').removeClass('activated');
        }
    };

    _updateStickySections = () => {
        let self = this;
        
        if ($(window).scrollTop() + $(window).height() < self._elems.$slider.offset().top + self._elems.$slider.height()) {
            $('.chess-section').each(function() {
                var $prop = $(this).find('.chess-section__prop');
                var $grid = $(this).find('.chess-section__grid');
                var $rest_parts = $(this).find('.chess-section__floors, .chess-section__floor-selections');

                if (self._elems.$slider.offset().top + $grid.outerHeight() >= $(window).scrollTop() + $(window).height()) {
                    $grid.css({
                        'top': '0',
                        'bottom': 'auto'
                    });

                    $rest_parts.css({
                        'top': '-' + ($prop.height() - $grid.height()) + 'px',
                        'bottom': 'auto'
                    });
                }
                else {
                    $grid.css({
                        'top': 'auto',
                        'bottom': ((self._elems.$slider.offset().top + self._elems.$slider.outerHeight()) - ($(window).scrollTop() + $(window).height())) + 'px'
                    });

                    $rest_parts.css({
                        'top': '-' + ((self._elems.$slider.offset().top + self._elems.$slider.outerHeight()) - ($(window).scrollTop() + $(window).height())) + 'px',
                        'bottom': 'auto'
                    });
                }
            });
        }
        else {
            var $grid = $('.chess-section__grid');
            var $rest_parts = $grid.add($('.chess-section__floors, .chess-section__floor-selections'));

            $grid.add($rest_parts).css({
                'top': '',
                'bottom': ''
            });
        }

        if ($(window).scrollTop() > self._elems.$control.offset().top) {
            self._elems.$control.addClass('fixed');

            $('.chess-section__extra, .chess-section__name')
                .add('.chess-section__global-selection, .chess-section__column-selections')
                .add('.chess-section__clone, .chess-section__edit, .chess-section__delete')
                .add('.chess-section__actions .hamburger')
                .add('.chess-section__layout')
                .css({
                    'top': ($(window).scrollTop() - self._elems.$slider.offset().top + self._elems.$control.outerHeight()) + 71 + 'px'
                });
        }
        else {
            self._elems.$control.removeClass('fixed');

            $('.chess-section__extra, .chess-section__name')
                .add('.chess-section__global-selection, .chess-section__column-selections')
                .add('.chess-section__clone, .chess-section__edit, .chess-section__delete')
                .add('.chess-section__actions .hamburger')
                .add('.chess-section__layout')
                .css({
                    'top': ''
                });
        }
    };

    _updateFlatTitles = () => {
        let self = this;

        let $sections = self._elems.$slider.children();
        let last_flat_number = 0;

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(current_section, current_section_index) {
            let $current_section = $sections.eq(current_section_index).children();
            $current_section.addClass('column-' + current_section.count_of_columns);
            let $grid = $current_section.find('.chess-section__grid');
            let $floors = $grid.find('.chess-section__grid__floor');

            last_flat_number = current_section.flats.sort(function(flat0, flat1) {
                let floor0 = self.getFloorById(current_section, flat0.floor_id);
                let floor1 = self.getFloorById(current_section, flat1.floor_id);

                if (floor0.index < floor1.index)
                    return -1;
                if (floor0.index > floor1.index)
                    return +1;
                if (flat0.column_index < flat1.column_index)
                    return -1;
                if (flat0.column_index > flat1.column_index)
                    return +1;

                return 0;
            }).reduce(function(number, flat, flat_index, flats) {
                let floor = self.getFloorById(current_section, flat.floor_id);
                let $flat = $floors.eq($floors.length - floor.index - 1).find('.chess-flat').eq(flat.column_index);

                if (flat.type == 'office') {
                    if (flat.group && flat.group.main_flat_id != flat.id) {
                        var main_flat = flats.filter(function(flat0) {
                            return flat0.id == flat.group.main_flat_id;
                        }).slice(0, 1).pop() || null;

                        $flat.find('.chess-flat__number').text('');
                        $flat.find('.chess-flat__rooms').text('');
                        flat.number = main_flat.number;
                        return number;
                    }

                    $flat.find('.chess-flat__number').text(flat.number || '?');
                    $flat.find('.chess-flat__rooms').text('КП');
                    return number;
                }

                if (flat.number.toString().match(/([А-Яа-яA-Za-z]+)$/)) {
                    $flat.find('.chess-flat__number').text(flat.number);
                    return number;
                }

                if (flat.group && flat.group.main_flat_id != flat.id) {
                    $flat.find('.chess-flat__number').text('');
                    $flat.find('.chess-flat__rooms').text('');
                    flat.number = 0;
                    return number;
                }

                $flat.find('.chess-flat__number').text(number);
                $flat.find('.chess-flat__rooms').text(flat.count_of_rooms == 0 ? 'С' : flat.count_of_rooms);
                flat.number = number;
                return number + 1;
            }, current_section.first_flat_number > 0 ? current_section.first_flat_number : (last_flat_number > 0 ? last_flat_number : 1));
        });
    };

    enableMainFlatSelectionMode = (section, section_index, $section, flats, callback) => {
        let self = this;

        self._state.main_flat_selection_mode = true;

        self._state.main_flat_selection_mode_callback = function(main_flat) {
            callback(main_flat);
            self.disableMainFlatSelectionMode();
            self.updateButtons();
        };

        self._elems.$_.addClass('main-flat-selection');
        let $grid = $section.find('.chess-section__grid');
        let $floors = $grid.find('.chess-section__grid__floor');

        flats.forEach(function(flat) {
            let $flat = $floors.eq($floors.length - flat.floor_index - 1).find('.chess-flat').eq(flat.column_index);
            $flat.addClass('to-select');
        });

        self.updateButtons();
    };

    disableMainFlatSelectionMode = () => {
        let self = this;

        self._state.main_flat_selection_mode = false;
        self._state.main_flat_selection_mode_callback = null;
        self._elems.$_.removeClass('main-flat-selection');
        self._elems.$_.find('.chess-flat.to-select').removeClass('to-select');
    };

    select = (section, $section, elements) => {
        let self = this;

        let $sections = self._elems.$slider.children();

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(current_section, current_section_index) {
            if (current_section.id == section.id) return;

            let $current_section = $sections.eq(current_section_index).children();
            let $current_section_flats = $current_section.find('.chess-flat');
            let $current_section_floors = $current_section.find('.chess-floor');
            $current_section_flats.removeClass('selected');
            $current_section_floors.removeClass('selected');

            self.updateSelection(current_section, $current_section, {
                $flats: $current_section_flats,
                $floors: $current_section_floors,
            }, false);
        });

        elements.$flats && elements.$flats.addClass('selected');
        elements.$floors && elements.$floors.addClass('selected');
        self.updateSelection(section, $section, elements, true);
        self.updateSelectedCount();
        self.updateButtons();
    };

    unselect = (section, $section, elements) => {
        let self = this;

        elements.$flats && elements.$flats.removeClass('selected');
        elements.$floors && elements.$floors.removeClass('selected');
        self.updateSelection(section, $section, elements, false);
        self.updateSelectedCount();
        self.updateButtons();
    };

    _unselectAll = () => {
        let self = this;

        let $sections = self._elems.$slider.children();

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(section, section_index) {
            let $section = $sections.eq(section_index).children();
            let $flats = $section.find('.chess-flat');
            let $floors = $section.find('.chess-floor');
            $flats.removeClass('selected');
            $floors.removeClass('selected');
            self._state.selected_floors[section.id] = [];
            self._state.selected_flats[section.id] = [];

            self.updateSelection(section, $section, {
                $flats: $flats,
                $floors: $floors,
            }, false);
        });

        self.updateSelectedCount();
        self.updateButtons();
    };

    updateSelection = (section, $section, elements, is_selected) => {
        let self = this;

        let floor_indexes = [], column_indexes = [];

        elements.$flats && elements.$flats.each(function() {
            let column_index = $(this).index();
            let floor_index = $(this).parent().parent().children().length - $(this).parent().index() - 1;
            column_indexes.indexOf(column_index) < 0 && column_indexes.push(column_index);
            floor_indexes.indexOf(floor_index) < 0 && floor_indexes.push(floor_index);

            if (is_selected) {
                let flat_is_already_selected = self._state.selected_flats[section.id].some(function(current_flat, current_flat_index) {
                    if (current_flat.floor_index != floor_index) return false;
                    if (current_flat.column_index != column_index) return false;

                    return true;
                });

                !flat_is_already_selected && self._state.selected_flats[section.id].push($(this).attr('data-id') ? {
                    id: 			parseInt($(this).attr('data-id')),
                    floor_index: 	floor_index,
                    column_index: 	column_index,
                    group_id      : $(this).attr('data-group-id') != undefined ? parseInt($(this).attr('data-group-id')) : 0,
                } : {
                    floor_index: 	floor_index,
                    column_index: 	column_index,
                    group_id      : $(this).attr('data-group-id') != undefined ? parseInt($(this).attr('data-group-id')) : 0,
                });
            }
            else {
                let flat_index = -1;

                self._state.selected_flats[section.id].some(function(current_flat, current_flat_index) {
                    if (current_flat.floor_index != floor_index) return false;

                    if (current_flat.column_index != column_index) return false;

                    flat_index = current_flat_index;
                    return true;
                });

                (flat_index > -1) && self._state.selected_flats[section.id].splice(flat_index, 1);
            }
        });

        elements.$floors && elements.$floors.each(function() {
            let floor_index = $(this).parent().children().length - $(this).index() - 1;
            floor_indexes.indexOf(floor_index) < 0 && floor_indexes.push(floor_index);

            if (is_selected) {
                let floor_is_already_selected = self._state.selected_floors[section.id].indexOf(floor_index) > -1;
                !floor_is_already_selected && self._state.selected_floors[section.id].push(floor_index);
            }
            else {
                let selected_floor_index = -1;
                selected_floor_index = self._state.selected_floors[section.id].indexOf(floor_index);
                (selected_floor_index > -1) && self._state.selected_floors[section.id].splice(selected_floor_index, 1);
            }
        });

        let $floor_selections = $section.find('.chess-section__floor-selections').children();
        let $grid = $section.find('.chess-section__grid');
        let $floors = $grid.find('.chess-section__grid__floor');
        let $floor_titles = $section.find('.chess-section__floors').children();

        floor_indexes.forEach(function(floor_index) {
            let $checkbox = $floor_selections.eq($floor_selections.length - floor_index - 1).find('.checkbox');
            let $floor = $floors.eq($floors.length - floor_index - 1);
            let $flats = $floor.find('.chess-flat');
            let $floor_title = $floor_titles.eq($floor_titles.length - floor_index - 1);

            let every_flat_is_selected = $flats.toArray().every(function(element) {
                return $(element).hasClass('selected');
            });

            let floor_is_selected = $floor_title.hasClass('selected');
            floor_is_selected && every_flat_is_selected ? $checkbox.addClass('checked') : $checkbox.removeClass('checked');
        });

        let $column_selections = $section.find('.chess-section__column-selections').children();

        column_indexes.forEach(function(column_index) {
            let $checkbox = $column_selections.eq(column_index).find('.checkbox');
            let $flats = $([]);

            $floors.each(function() {
                $flats = $flats.add($(this).find('.chess-flat').eq(column_index));
            });

            let every_flat_is_selected = $flats.toArray().every(function(element) {
                return $(element).hasClass('selected');
            });

            every_flat_is_selected ? $checkbox.addClass('checked') : $checkbox.removeClass('checked');
        });

        let every_floor_selection_is_checked = $floor_selections.find('.checkbox').toArray().every(function(element) {
            return $(element).hasClass('checked');
        });

        let every_column_selection_is_checked = $column_selections.find('.checkbox').toArray().every(function(element) {
            return $(element).hasClass('checked');
        });

        let $global_selection = $section.find('.chess-section__global-selection');

        if (every_floor_selection_is_checked && every_column_selection_is_checked) {
            $global_selection.find('.checkbox').addClass('checked');
        }
        else {
            $global_selection.find('.checkbox').removeClass('checked');
        }
    };

    hoverFloor = (section, $section, floor_index) => {
        let $grid_floors = $section.find('.chess-section__grid').children();
        let $floor_titles = $section.find('.chess-section__floors').children();
        let $floor_selections = $section.find('.chess-section__floor-selections').children();
        $grid_floors.eq($grid_floors.length - floor_index - 1).addClass('hover');
        $floor_titles.eq($floor_titles.length - floor_index - 1).addClass('hover');
        $floor_selections.eq($floor_selections.length - floor_index - 1).addClass('hover');
    };

    unhoverFloor = (section, $section, floor_index) => {
        let $grid_floors = $section.find('.chess-section__grid').children();
        let $floor_titles = $section.find('.chess-section__floors').children();
        let $floor_selections = $section.find('.chess-section__floor-selections').children();
        $grid_floors.eq($grid_floors.length - floor_index - 1).removeClass('hover');
        $floor_titles.eq($floor_titles.length - floor_index - 1).removeClass('hover');
        $floor_selections.eq($floor_selections.length - floor_index - 1).removeClass('hover');
    };

    updateSelectedCount = () => {
        let self = this;

        let selected_flats  = self._getSelectedFlats();
        let selected_floors = self._getSelectedFloors();

        if (selected_flats.length > 0 || selected_floors.length > 0) {
            const section_id = (selected_flats.length > 0 ? selected_flats[0].id : selected_floors[0].id);
            let section = self._getSectionById(section_id);
            $('.chess__control__selected').addClass('activated');

            $('.chess__control__selected__apartment-count').text(selected_flats.length > 0 ? selected_flats[0].flats.filter(function(selected_flat) {
                return selected_flat.id;
            }).map(function(selected_flat) {
                return section.flats.filter(function(flat) {
                    return flat.id == selected_flat.id;
                }).slice(0, 1).pop() || null;
            }).filter(function(flat) {
                return ['flat', 'apartment'].indexOf(flat.type) !== -1;
            }).filter(function(flat) {
                return !flat.group || flat.group.main_flat_id == flat.id;
            }).length : 0);

            $('.chess__control__selected__office-count').text(selected_flats.length > 0 ? selected_flats[0].flats.filter(function(selected_flat) {
                return selected_flat.id;
            }).map(function(selected_flat) {
                return section.flats.filter(function(flat) {
                    return flat.id == selected_flat.id;
                }).slice(0, 1).pop() || null;
            }).filter(function(flat) {
                return flat.type == 'office';
            }).filter(function(flat) {
                return !flat.group || flat.group.main_flat_id == flat.id;
            }).length : 0);

            $('.chess__control__selected__empty-count').text(selected_flats.length > 0 ? selected_flats[0].flats.filter(function(selected_flat) {
                return !selected_flat.id;
            }).length : 0);

            $('.chess__control__selected__floor-count').text(selected_floors.length > 0 ? selected_floors[0].floors.length : 0);
        }
        else {
            $('.chess__control__selected__apartment-count').text('0');
            $('.chess__control__selected__office-count').text('0');
            $('.chess__control__selected__empty-count').text('0');
            $('.chess__control__selected__floor-count').text('0');
            $('.chess__control__selected').removeClass('activated');
        }
    };

    updateButtons = () => {
        let self = this;

        if (self._state.main_flat_selection_mode) {
            $('.js-profile-control-add').addClass('disabled');
            $('.js-profile-control-edit').addClass('disabled');
            $('.js-profile-control-delete').addClass('disabled');
        }
        else {
            let $selected_flats = self._elems.$slider.find('.chess-flat.selected');
            let $selected_floors = self._elems.$slider.find('.chess-floor.selected');

            if ($selected_flats.length > 0) {
                let $existent_selected_flats = $selected_flats.filter('.existent');
                let $non_existent_selected_flats = $selected_flats.filter('.non-existent');

                let group_ids = $existent_selected_flats.toArray().map(function(element) {
                    return $(element).attr('data-group-id') ? parseInt($(element).attr('data-group-id')) : 0;
                }).filter(function(group_id) {
                    return group_id > 0;
                }).filter(function(group_id, group_id_index, group_ids) {
                    return group_ids.indexOf(group_id) == group_id_index;
                });

                if ($existent_selected_flats.length > 0) {
                    $('.js-profile-control-delete').removeClass('disabled');
                    $('.js-profile-edit-flats, .js-profile-control-flats-delete').removeClass('disabled');
                }
                else {
                    $('.js-profile-control-delete').addClass('disabled');
                    $('.js-profile-edit-flats, .js-profile-control-flats-delete').addClass('disabled');
                }

                if ($non_existent_selected_flats.length > 0) {
                    $('.js-profile-control-add-flats').removeClass('disabled');
                }
                else {
                    $('.js-profile-control-add-flats').addClass('disabled');
                }

                if ($non_existent_selected_flats.length > 1) {
                    let allow_to_group = (function() {
                        let flats = $non_existent_selected_flats.toArray().map(function(element) {
                            let $floor = $(element).parent();
                            let $grid = $floor.parent();

                            return {
                                floor_index: $grid.children().length - $floor.index() - 1,
                                column_index: $(element).index(),
                            };
                        });

                        let grouped_flats = [];
                        let flat_stack = [ flats[0] ];

                        while (flat_stack.length > 0) {
                            let last_flat = flat_stack.slice(-1).pop();

                            let flat_exists = flats.some(function(flat) {
                                return flat.floor_index == last_flat.floor_index && flat.column_index == last_flat.column_index;
                            });

                            if (!flat_exists) {
                                flat_stack.pop();
                                continue;
                            }

                            let grouped_flat_exists = grouped_flats.some(function(grouped_flat) {
                                return grouped_flat.floor_index == last_flat.floor_index && grouped_flat.column_index == last_flat.column_index;
                            });

                            if (grouped_flat_exists) {
                                flat_stack.pop();
                                continue;
                            }

                            grouped_flats.push(last_flat);

                            flat_stack.push({
                                floor_index: 	last_flat.floor_index - 1,
                                column_index: 	last_flat.column_index,
                            });

                            flat_stack.push({
                                floor_index: 	last_flat.floor_index + 1,
                                column_index: 	last_flat.column_index,
                            });

                            flat_stack.push({
                                floor_index: 	last_flat.floor_index,
                                column_index: 	last_flat.column_index - 1,
                            });

                            flat_stack.push({
                                floor_index: 	last_flat.floor_index,
                                column_index: 	last_flat.column_index + 1,
                            });
                        }

                        return grouped_flats.length == flats.length;
                    })();

                    if (allow_to_group) {
                        $('.js-profile-add-flats.group').removeClass('disabled');
                    }
                    else {
                        $('.js-profile-add-flats.group').addClass('disabled');
                    }
                }
                else {
                    $('.js-profile-add-flats.group').addClass('disabled');
                }

                let diff = false;
                for (let i in self._state.selected_flats) {
                    let section = self._state.selected_flats[i];
                    for (let j in section) {
                        for (let k in section) {
                            if (section[j].id != section[k].id && section[j].group_id != section[k].group_id) {
                                diff = true;
                            }
                        }
                    }
                }
                if (!diff && group_ids.length == 1) {
                    $('.js-profile-edit-main-flat').show();
                }
                else {
                    $('.js-profile-edit-main-flat').hide();
                }
            }
            else {
                $('.js-profile-control-add-flats, .js-profile-add-flats.group').removeClass('disabled');
                $('.js-profile-edit-flats, .js-profile-control-flats-delete').removeClass('disabled');
                $('.js-profile-edit-main-flat').hide();
            }

            $('.js-profile-control-add').removeClass('disabled');
            $('.js-profile-control-edit').removeClass('disabled');
        }
    };

    _getSelectedFlats = () => {
        let self = this;

        let selected_flats = [];

        Object.keys(self._state.selected_flats).forEach(function(section_id) {
            if (!self._state.selected_flats[section_id].length) return;

            selected_flats.push({
                id: parseInt(section_id),
                flats: self._state.selected_flats[section_id],
            });
        });

        return selected_flats;
    };

    _getSelectedFloors = () => {
        let self = this;

        let selected_floors = [];

        Object.keys(self._state.selected_floors).forEach(function(section_id) {
            if (!self._state.selected_floors[section_id].length) return;

            let section = self._getSectionById(section_id);

            selected_floors.push({
                id: parseInt(section_id),

                floors: self._state.selected_floors[section_id].map(function(selected_floor_index) {
                    if (selected_floor_index < 0 || selected_floor_index >= section.floors.length)
                        return null;
                    return selected_floor_index;
                }).filter(function(floor_index) {
                    return section.floors[floor_index];
                }).map(function(floor_index) {
                    return { id: section.floors[floor_index].id, index: floor_index };
                })
            });
        });

        return selected_floors;
    };

    _getNonExistentSelectedFlats = () => {
        let self = this;

        let non_existent_selected_flats = [];

        Object.keys(self._state.selected_flats).forEach(function(section_id) {
            let selected_flats_of_the_section = self._state.selected_flats[section_id].filter(function(flat) {
                return !flat.id;
            });

            if (!selected_flats_of_the_section.length) return;

            non_existent_selected_flats.push({
                id: parseInt(section_id),
                flats: selected_flats_of_the_section,
            });
        });

        return non_existent_selected_flats;
    };

    getExistentSelectedFlats = () => {
        let self = this;

        let existent_selected_flats = [];

        Object.keys(self._state.selected_flats).forEach(function(section_id) {
            let selected_flats_of_the_section = self._state.selected_flats[section_id].filter(function(flat) {
                return flat.id;
            });

            if (!selected_flats_of_the_section.length) return;

            existent_selected_flats.push({
                id    : parseInt(section_id),
                flats : selected_flats_of_the_section,
            });
        });

        return existent_selected_flats;
    };

    extraClickHandler = (e) => {
        if ($(e.target).is('.chess__control__close-extra')) {
            e.preventDefault();
            $('.chess__control__extra').removeClass('active');
            return;
        }

        if ($(e.target).closest('.chess__control__extra').length > 0) return;
        if ($(e.target).is('.js-profile-control-add')) return;
        if ($(e.target).is('.js-profile-control-edit')) return;
        if ($(e.target).is('.js-profile-control-delete')) return;
        if ($(e.target).closest('.modal').length > 0) return;

        $('.chess__control__extra').removeClass('active');
    };

    destroy = () => {
        $(document).off('click', self.extraClickHandler);
    };

    getFloorById = (section, floor_id) => {
        return section.floors.filter(function(floor) {
            return floor.id == floor_id;
        }).slice(0, 1).pop() || null;
    };

    getFlatByIndexes = (section, floor_index, column_index) => {
        let flat = null;
        if (floor_index < 0 || floor_index >= section.floors.length)
            return flat;

        let floor = section.floors[floor_index];
        section.flats.some(function(current_flat) {
            if (current_flat.floor_id != floor.id)
                return false;
            if (current_flat.column_index != column_index)
                return false;
            flat = current_flat;
            return true;
        });

        return flat;
    };

    _getSectionById = (section_id) => {
        let self    = this;

        let section = null;

        self._args.building.sections.some(function(current_section) {
            if (current_section.id != section_id) return false;

            section = current_section;
            return true;
        });

        return section;
    };

    getFloorBySectionAndId = (section, floor_id) => {
        let floor = null;
        section.floors.some(function(current_floor) {
            if (current_floor.id != floor_id)  return false;
            floor = current_floor;
            return true;
        });
        return floor;
    };

    _getFlatBySectionAndId = (section, flat_id) => {
        let flat = null;
        section.flats.some(function(current_flat) {
            if (current_flat.id != flat_id) return false;
            flat = current_flat;
            return true;
        });
        return flat;
    };

    _render = () => {
        let self = this;

        if (self._args.building.sections.length > 0) {
            self._elems.$slider.html('');
            self._args.building.sections.sort(function(s1, s2) {
                return s1.number - s2.number;
            }).forEach(function () {
                $('<div />').addClass('chess__section').appendTo(self._elems.$slider);
            });
        }
        else {
            self._elems.$slider.find('.chess__section').remove();
            $('<div />').addClass('chess__no-sections').html(Utils.renderProfileTemplate('no-sections')).appendTo(self._elems.$slider);
        }

        self._updateSections();

        self._state.controlSection = new Section({
            mode     : Vars.view.control,
            building : self._args.building,
            progress : self._args.progress,
            item     : {},
            root     : self._elems.$control,
            chess    : self
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$control.find('.chess__control__button.left').click(function (e) {
            e.preventDefault();

            self._elems.$wrapper.stop().animate({
                scrollLeft : self._elems.$wrapper.scrollLeft() - 200,
            }, 'fast');
        });

        self._elems.$control.find('.chess__control__button.right').click(function (e) {
            e.preventDefault();

            self._elems.$wrapper.stop().animate({
                scrollLeft: self._elems.$wrapper.scrollLeft() + 200,
            }, 'fast');
        });

        self._elems.$control.find('.chess__control__selected__cross').click(function (e) {
            e.preventDefault();

            if (self._state.main_flat_selection_mode) {
                self.disableMainFlatSelectionMode();
            }

            self._unselectAll();
        });

        self._elems.$wrapper.mousedown(function (e) {
            e.preventDefault();
            self._state.scrolling = true;
            self._state.scrollingwrapperPosition = self._elems.$wrapper.scrollLeft();
            self._state.scrollingStartedPosition = e.pageX;
        });

        self._elems.$wrapper.mousemove(function (e) {
            if (!self._state.scrolling) return;

            e.preventDefault();
            self._state.scrollingMoving = (Math.abs(self._state.scrollingStartedPosition - e.pageX) > 5);
            self._elems.$wrapper.scrollLeft(self._state.scrollingwrapperPosition + (self._state.scrollingStartedPosition - e.pageX));
        });

        self._elems.$wrapper.scroll(function(){
            self._updateCurrentSection()
        });

        self._elems.$wrapper.mouseup(function (e) {
            if (!self._state.scrolling)
                return;

            e.preventDefault();
            if (self._state.scrolling_moving) {
                self._state.afterScroll = true;
                setTimeout(function () {
                    delete self._state.afterScroll;
                });
            }

            delete self._state.scrolling;
            delete self._state.scrolling_moving;
            delete self._state.scrolling_wrapper_position;
            delete self._state.scrolling_started_position;
        });

        self._elems.$wrapper.scroll(function(){
            self._updateCurrentSection()
        });
        $(window).scroll(function(){
            self._updateStickySections()
        });
        $(window).resize(function () {
            self._updateCurrentSection();
            self._updateStickySections();
        });

        self._updateCurrentSection();
        self._updateStickySections();

        $(document).on('click', self.extraClickHandler);
    };

    _init = () => {
        let self = this;

        self._render();
        self._bindUI();
    };

    _initializeSection = (section, section_index, $section) => {
        let self = this;
        let $floors = $section.find('.chess-section__grid__floor');

        $floors.each(function() {
            let $floor = $(this);

            $floor.find('.chess-flat').each(function() {
                let $flat = $(this);

                $flat.click(function(e) {
                    e.preventDefault();

                    if (self._state.scrolling || self._state.afterScroll) return;

                    if ($flat.hasClass('to-select')) {
                        if (!self._state.main_flat_selection_mode) return;

                        if ($flat.attr('data-id')) {
                            let flat = self._getFlatBySectionAndId(section, parseInt($flat.attr('data-id')));
                            self._state.main_flat_selection_mode_callback(flat);
                        }
                        else {
                            self._state.main_flat_selection_mode_callback({
                                floor_index: $floors.length - $floor.index() - 1,
                                column_index: $flat.index(),
                            });
                        }

                        return;
                    }

                    if ($flat.attr('data-group-id')) {
                        let $grouped_flats = $section.find('.chess-flat[data-group-id="' + $flat.attr('data-group-id') + '"]');

                        if ($flat.hasClass('selected')) {
                            self.unselect(section, $section, { $flats: $grouped_flats });
                        } else {
                            self.select(section, $section, { $flats: $grouped_flats });
                        }

                        return;
                    }

                    if ($flat.hasClass('selected')) {
                        self.unselect(section, $section, { $flats: $flat });
                    }
                    else {
                        self.select(section, $section, { $flats: $flat });
                    }
                });

                $flat.hover(function(event) {
                    if ($(this).attr('data-group-id')) {
                        $section.find('.chess-flat[data-group-id="' + $(this).attr('data-group-id') + '"]').addClass('hover');
                    }
                    else {
                        $(this).addClass('hover');
                    }
                }, function(event) {
                    if ($(this).attr('data-group-id')) {
                        $section.find('.chess-flat[data-group-id="' + $(this).attr('data-group-id') + '"]').removeClass('hover');
                    }
                    else {
                        $(this).removeClass('hover');
                    }
                });
            });
        });

        let $floor_titles = $section.find('.chess-section__floors').children();

        $floor_titles.click(function(e) {
            e.preventDefault();

            if ($(this).hasClass('empty')) return;

            if ($(this).hasClass('selected')) {
                self.unselect(section, $section, { $floors: $(this) });
            } else {
                self.select(section, $section, { $floors: $(this) });
            }
        });

        /*$section.find('.chess-section__delete').click(function(event) {
            event.preventDefault();

            new Modal({
                title: 		'Удаление секции',
                content: 	Utils.renderProfileTemplate('section-deleting-confirmation', {section: section}),
            });

            $('#delete-section-form').find('.button:not(.red)').click(function(event) {
                event.preventDefault();
                modals.last.close();
            });

            $('#delete-section-form').find('.button.red').click(function(event) {
                event.preventDefault();
                loader.increase();

                return profile.request({
                    path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/sections/' + section.id + '/delete',
                    done: function(response) {
                        loader.decrease();

                        if (response.error) return;

                        modals.last.close();
                        self._args.building.sections.splice(section_index, 1);
                        $section.parent().remove();
                        self._updateSections();
                        self._updateStickySections();
                        delete self._state.selected_flats[section.id];
                        self.updateSelectedCount();
                        self.updateButtons();

                        self._args.building.facades.forEach(function(facade) {
                            facade.polygons = facade.polygons.filter(function(polygon) {
                                return polygon['section_id'] != section.id;
                            });
                        });

                        if (!self._args.building.sections.length) {
                            $('<div />').addClass('chess__no-sections').html(Utils.renderProfileTemplate('no-sections')).appendTo($('.chess__slider'));
                        }
                    }
                });
            });
        });*/

        $section.find('.chess-section__extra').click(function(event) {
            event.preventDefault();
            $section.hasClass('showing-numbers') ? $section.removeClass('showing-numbers') : $section.addClass('showing-numbers');
        });

        var $grid = $section.find('.chess-section__grid');
        var $floor_selections = $section.find('.chess-section__floor-selections').find('.chess-selection');

        $floor_selections.click(function(event) {
            event.preventDefault();
            var floor_index = $floor_selections.length - $(this).index() - 1;
            var $checkbox = $(this).find('.checkbox');
            var $selected_flats = $floors.eq($floors.length - floor_index - 1).find('.chess-flat');
            var $floor_title = $floor_titles.eq($floor_titles.length - floor_index - 1);

            var $flats = $($.unique($selected_flats.toArray().reduce(function(flats, flat_element) {
                if ($(flat_element).attr('data-group-id')) {
                    flats = flats.concat($section.find('.chess-flat[data-group-id="' + $(flat_element).attr('data-group-id') + '"]').toArray());
                    return flats;
                }

                flats.push(flat_element);
                return flats;
            }, [])));

            if ($checkbox.hasClass('checked')) {
                self.unselect(section, $section, {
                    $flats: $flats,
                    $floors: $floor_title,
                });
            }
            else {
                self.select(section, $section, {
                    $flats: $flats,
                    $floors: $floor_title,
                });
            }
        });

        var $column_selections = $section.find('.chess-section__column-selections').find('.chess-selection');

        $column_selections.click(function(event) {
            event.preventDefault();
            var column_index = $(this).index();
            var $checkbox = $(this).find('.checkbox');
            var $selected_flats = $([]);

            $grid.find('.chess-section__grid__floor').each(function() {
                $selected_flats = $selected_flats.add($(this).find('.chess-flat').eq(column_index));
            });

            var $flats = $($.unique($selected_flats.toArray().reduce(function(flats, flat_element) {
                if ($(flat_element).attr('data-group-id')) {
                    flats = flats.concat($section.find('.chess-flat[data-group-id="' + $(flat_element).attr('data-group-id') + '"]').toArray());
                    return flats;
                }

                flats.push(flat_element);
                return flats;
            }, [])));

            if ($checkbox.hasClass('checked')) {
                self.unselect(section, $section, {
                    $flats: $flats,
                });
            }
            else {
                self.select(section, $section, {
                    $flats: $flats,
                });
            }
        });

        var $global_selection = $section.find('.chess-section__global-selection');

        $global_selection.click(function(event) {
            event.preventDefault();
            var $checkbox = $(this).find('.checkbox');
            var $flats = $grid.find('.chess-flat');

            if ($checkbox.hasClass('checked')) {
                self.unselect(section, $section, {
                    $flats: $flats,
                    $floors: $floor_titles.filter(':not(.empty)'),
                });
            }
            else {
                self.select(section, $section, {
                    $flats: $flats,
                    $floors: $floor_titles.filter(':not(.empty)'),
                });
            }
        });

        $floor_titles.filter(':not(.empty)').hover(function() {
            self.hoverFloor(section, $section, $floor_titles.length - $(this).index() - 1);
        }, function() {
            self.unhoverFloor(section, $section, $floor_titles.length - $(this).index() - 1);
        });

        $floor_selections.filter(':not(.empty)').hover(function() {
            self.hoverFloor(section, $section, $floor_selections.length - $(this).index() - 1);
        }, function() {
            self.unhoverFloor(section, $section, $floor_selections.length - $(this).index() - 1);
        });

        $floors.hover(function() {
            self.hoverFloor(section, $section, $floors.length - $(this).index() - 1);
        }, function() {
            self.unhoverFloor(section, $section, $floors.length - $(this).index() - 1);
        });
    };

    enableMainFlatSelectionMode = (section, section_index, $section, flats, callback) => {
        let self = this;
        self._state.main_flat_selection_mode = true;

        self._state.main_flat_selection_mode_callback = function(main_flat) {
            callback(main_flat);
            self.disableMainFlatSelectionMode();
            self.updateButtons();
        };

        self._elems.$_.addClass('main-flat-selection');
        let $grid = $section.find('.chess-section__grid');
        let $floors = $grid.find('.chess-section__grid__floor');

        flats.forEach(function(flat) {
            let $flat = $floors.eq($floors.length - flat.floor_index - 1).find('.chess-flat').eq(flat.column_index);
            $flat.addClass('to-select');
        });

        self.updateButtons();
    };

    disableMainFlatSelectionMode = () => {
        let self = this;

        self._state.main_flat_selection_mode = false;
        self._state.main_flat_selection_mode_callback = null;
        self._elems.$_.removeClass('main-flat-selection');
        self._elems.$_.find('.chess-flat.to-select').removeClass('to-select');
    };

    select = (section, $section, elements) => {
        let self = this;

        let $sections = self._elems.$slider.children();

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(current_section, current_section_index) {
            if (current_section.id == section.id) return;

            let $current_section = $sections.eq(current_section_index).children();
            let $current_section_flats = $current_section.find('.chess-flat');
            let $current_section_floors = $current_section.find('.chess-floor');
            $current_section_flats.removeClass('selected');
            $current_section_floors.removeClass('selected');

            self.updateSelection(current_section, $current_section, {
                $flats: $current_section_flats,
                $floors: $current_section_floors,
            }, false);
        });

        elements.$flats && elements.$flats.addClass('selected');
        elements.$floors && elements.$floors.addClass('selected');
        self.updateSelection(section, $section, elements, true);
        self.updateSelectedCount();
        self.updateButtons();
    };

    unselect = (section, $section, elements) => {
        var self = this;
        elements.$flats && elements.$flats.removeClass('selected');
        elements.$floors && elements.$floors.removeClass('selected');
        self.updateSelection(section, $section, elements, false);
        self.updateSelectedCount();
        self.updateButtons();
    };

    unselectAll = () => {
        let self = this;

        let $sections = self._elems.$slider.children();

        self._args.building.sections.sort(function(s1, s2) {
            return s1.number - s2.number;
        }).forEach(function(section, section_index) {
            let $section = $sections.eq(section_index).children();
            let $flats = $section.find('.chess-flat');
            let $floors = $section.find('.chess-floor');
            $flats.removeClass('selected');
            $floors.removeClass('selected');
            self._state.selected_floors[section.id] = [];
            self._state.selected_flats[section.id] = [];

            self.updateSelection(section, $section, {
                $flats: $flats,
                $floors: $floors,
            }, false);
        });

        self.updateSelectedCount();
        self.updateButtons();
    };
}

export default Chess;